import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";
import { Clock, Users, Target, CheckCircle, ArrowRight } from "lucide-react";
import { mockData } from "../mock";

export const Programs = () => {
  return (
    <section id="programs" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div id="program" className="text-center space-y-4 mb-16">
          <h2 className="text-4xl font-bold text-gray-900">
            Choose Your Track
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Whether you're a student or ready for a career change, we have the
            perfect program to fast-track your journey into tech.
          </p>
        </div>

        {/* Programs Grid */}
        <div className="grid lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {mockData.programs.map((program, index) => (
            <Card
              key={program.id}
              className={`relative overflow-hidden border-2 transition-all duration-300 hover:shadow-xl ${
                index === 1
                  ? "border-yellow-400 bg-gradient-to-br from-yellow-50 via-white to-white shadow-lg"
                  : "border-gray-200 hover:border-blue-300 bg-white"
              }`}
            >
              {/* Premium Badge */}
              {index === 1 && (
                <div className="absolute top-4 right-4">
                  <Badge className="bg-yellow-500 text-black font-semibold shadow-sm">
                    Industry Choice
                  </Badge>
                </div>
              )}

              <CardHeader className="pb-4">
                <CardTitle className="text-2xl text-gray-900">
                  {program.title}
                </CardTitle>
                <div className="flex flex-wrap gap-2 mt-2">
                  <Badge variant="outline" className="flex items-center gap-1">
                    <Clock size={14} />
                    {program.duration}
                  </Badge>
                  <Badge variant="outline" className="flex items-center gap-1">
                    <Users size={14} />
                    {program.audience}
                  </Badge>
                </div>
              </CardHeader>

              <CardContent className="space-y-6">
                <p className="text-gray-700 leading-relaxed">
                  {program.description}
                </p>

                <div className="space-y-3">
                  <div className="flex items-center gap-2">
                    <Target
                      className={`${
                        index === 1 ? "text-yellow-500" : "text-blue-600"
                      }`}
                      size={20}
                    />
                    <span className="font-semibold text-gray-900">
                      Outcome:
                    </span>
                  </div>
                  <p className="text-gray-700 pl-7">{program.outcome}</p>
                </div>

                <div className="space-y-3">
                  <h4 className="font-semibold text-gray-900">
                    What's Included:
                  </h4>
                  <ul className="space-y-2">
                    {program.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center gap-3">
                        <CheckCircle
                          className="text-green-500 flex-shrink-0"
                          size={16}
                        />
                        <span className="text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <Button
                  className={`w-full py-6 text-lg ${
                    index === 1
                      ? "bg-yellow-500 hover:bg-yellow-400 text-black font-semibold shadow-md"
                      : "bg-gray-900 hover:bg-gray-800 text-white"
                  }`}
                  onClick={() =>
                    window.open(
                      "https://api.whatsapp.com/send?phone=919895223307",
                      "_blank"
                    )
                  }
                >
                  {program.cta}
                  <ArrowRight className="ml-2" size={20} />
                </Button>

                <div className="text-center pt-2">
                  <p className="text-sm text-gray-500">
                    <strong>Mode:</strong> {program.schedule}
                  </p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <p className="text-gray-600 mb-6">
            Design Your Tech Career Path. Consult with our experts
          </p>
          <Button
            variant="outline"
            size="lg"
            type="button"
            className="
    px-10 py-6 text-lg font-semibold
    border-2 border-blue-600
    text-blue-600
    rounded-full
    bg-white
    shadow-md
    transition-all duration-300
    hover:bg-blue-600 hover:text-white
    hover:shadow-xl
    active:scale-95
  "
            onClick={() =>
              window.open(`tel:${mockData.contact.phone}`, "_self")
            }
          >
            Book a Free Consultation Call
          </Button>
        </div>
      </div>
    </section>
  );
};
